/**
 * Placeholder de carregamento mobile — pulso dourado suave (identidade Manafix).
 */
export default function MobileSkeleton({ lines = 3 }) {
  return (
    <div className="space-y-3 px-4 py-3" aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <div
          key={i}
          className="h-12 animate-pulse rounded-lg border border-primary/10 bg-monao"
          style={{ animationDelay: `${i * 120}ms` }}
        />
      ))}
    </div>
  );
}
